import { Stack, Typography} from "@mui/material";
import { formatDate } from "@telerik/kendo-intl";
import React from "react"
import { useParams } from "react-router";
import { useAppSelector } from "../../../../../app/hooks";
import { useCaseFindQuery } from "../../../../../services/scheduleService/schedule-api";
import './Header.css'
import { PatientDetails } from "./PatientDetails";

type ownProps ={
    visitId:string;
    centerId:string;
}
function Header(props:ownProps){
    const {id} = useParams();
    const schedule = useCaseFindQuery(id!);
    const verify = useAppSelector((state) => state.verification.verification);

    const lastName = verify.lastName || schedule.data?.lastName || '';
    const firstName = verify.firstName || schedule.data?.firstName || '';
    const birthDate = verify.birthDate || schedule.data?.birthDate;
    const serviceDate = verify.serviceDate || schedule.data?.serviceDate;
    const accountNumber = verify.accountNumber || schedule.data?.accountNumber || '';

    return <React.Fragment>
        <Stack direction='row' justifyContent='space-between' alignItems='center' sx={{marginBottom:'5px'}}>
            <Typography variant='h6' color='gray'>{lastName || firstName ? lastName + ', ' + firstName : ''}
                <PatientDetails/>
            </Typography>
            <Typography variant='h6' color='gray'>{accountNumber}</Typography>
            <Typography variant='h6' color='gray'>{'Birth Date: ' + (birthDate ? formatDate(new Date(birthDate),'MM/dd/yyyy') : '')}</Typography>
            <Typography variant='h6' color='gray'>{'Service Date: ' + (serviceDate ? formatDate(new Date(serviceDate),'MM/dd/yyyy') : '')}</Typography>
            {/* <CommandBar/> */}
        </Stack>


    </React.Fragment>
}

export {Header}